import Icons from '../../Icons'
import { lightTheme } from '@/customTheme'
import { useAppDispatch } from '@/store/store'
import { setOpenModalTryPremium } from '@/store/slices/user/actions'
import { SyncManager } from '@/firebase/SyncManager'
import ButtonCustom from '@/components/ButtonCustom'
import { SizeButton } from '@/constants/sizeButton'
import { KIND } from 'baseui/button'
import { LabelLarge } from 'baseui/typography'
import { useTranslation } from 'react-i18next'
import { ShowModalType } from '@/scenes/engine/common/constants'
import { NavbarButtonBaseProps } from '../navbarConfig'
import useModal from '@/hooks/useModal'

function SignInButton({ disabled = false }: NavbarButtonBaseProps) {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const { setShowModalType } = useModal()

  return (
    <ButtonCustom
      type={SizeButton.STANDARD}
      kind={KIND.secondary}
      style={{
        width: '108px',
        minWidth: 'fit-content',
        gap: '6px',
        ...(disabled ? { background: lightTheme.colors.grayScale50 } : {}),
        opacity: !SyncManager.shared.hasConnection ? lightTheme.opacity.disabled : lightTheme.opacity.active
      }}
      onClick={e => {
        e.preventDefault()
        e.stopPropagation()
        setShowModalType(ShowModalType.SIGN_IN)
        dispatch(
          setOpenModalTryPremium({
            isOpen: false,
            source: null,
            callback: null,
            opened: false,
          })
        )
      }}
      disabled={disabled || !SyncManager.shared.hasConnection}
    >
      <Icons.DefaultAvatar
        fill={
          disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray
        }
      />
      <LabelLarge
        $style={{
          ...lightTheme.typography.Small14Semibold,
          color: disabled
            ? lightTheme.colors.grayScale200
            : lightTheme.colors.blackGray,
        }}
      >
        {t('Sign in')}
      </LabelLarge>
    </ButtonCustom>
  )
}

export default SignInButton
